"use client";
import { jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { useProductTileData } from "../../../../../../../hooks/useProductTileData/index.js";
import { ProductDeliveryBadge } from "./ProductDeliveryBadge/index.js";
import { containerStyles } from "./styles.js";
const ProductDeliveryBadgeAddtoList = () => {
  const { normalizedData } = useProductTileData();
  const { productDeliveryBadgeData, productInfoData } = normalizedData;
  if (!productDeliveryBadgeData) return null;
  return /* @__PURE__ */ jsx(
    Box,
    {
      "data-testid": `ProductDeliveryBadge_${productInfoData.partNumber}`,
      sx: containerStyles,
      children: /* @__PURE__ */ jsx(ProductDeliveryBadge, {})
    }
  );
};
export {
  ProductDeliveryBadgeAddtoList
};
